import React, { FC, memo } from 'react';
import { useNavigate } from 'react-router';

import Typography from '@mui/material/Typography';

import Button from '@components/common/Button';

import {
  QUICK_FIND_VAULTS_LINKS,
  QUICK_LINKS,
  TOOLS_ITEMS,
} from '@constants/common/menu.constants';
import { PATH_CREATE_VAULT } from '@constants/common/routes.constants';
import { Variant } from '@constants/common/ui.constants';

import Card from '../Card';
import Item from '../Item';

interface Props {
  onClose: () => void;
}

const Vaults: FC<Props> = ({ onClose }) => {
  const navigate = useNavigate();

  const handleRedirect = (path: string) => {
    navigate(path);
    onClose();
  };

  return (
    <Card title="Vaults">
      <Typography variant="h4" color={(theme) => theme.secondary.s3}>
        Quick links
      </Typography>
      {QUICK_LINKS.map(
        ({ title, path, icon }) =>
          path && (
            <Item
              key={`menu-${title}`}
              label={title}
              path={path}
              icon={icon}
              onClose={onClose}
              withPadding
            />
          ),
      )}
      <Typography variant="h4" color={(theme) => theme.secondary.s3}>
        Find a vault
      </Typography>
      {QUICK_FIND_VAULTS_LINKS.map(
        ({ title, href, icon }) =>
          href && (
            <Item
              key={`menu-${title}`}
              label={title}
              path={href}
              icon={icon}
              onClose={onClose}
              withPadding
            />
          ),
      )}
      <Typography variant="h4" color={(theme) => theme.secondary.s3}>
        Tools
      </Typography>
      {TOOLS_ITEMS.map(({ title, path, icon, isComingSoon, newTab }) =>
        path === PATH_CREATE_VAULT ? (
          <Button
            key={`menu-${title}`}
            variant={Variant.Gradient}
            onClick={() => handleRedirect(path)}
          >
            <Typography variant="subtitle1" color={(theme) => theme.primary.p2}>
              {title}
            </Typography>
          </Button>
        ) : (
          <Item
            key={`menu-${title}`}
            label={title}
            path={path}
            icon={icon}
            isComingSoon={isComingSoon}
            newTab={newTab}
            onClose={onClose}
            withPadding
          />
        ),
      )}
    </Card>
  );
};

export default memo(Vaults);
